/*let lastScroll = 0;
const initFixedMenu = () => {
  const scrollUp = "scroll-up";
  const scrollDown = "scroll-down";
  const scrollHandler = () =>{

    const body = document.body;
    const el = document.querySelector('#main')
    let viewportOffset = el.getBoundingClientRect();
    const top = viewportOffset.top;
    const currentScroll = window.scrollY;
    if (currentScroll <= 0) {
      body.classList.remove(scrollUp);
      return;
    }
    if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && (top < 0)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if ( currentScroll < lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
  }
  window.addEventListener("scroll", scrollHandler);
  scrollHandler();
};
*/
let lastScrollTop = 0;
const initFixedMenu = () => {
    const setMenuPosition = () => {
        const mainNavbar = document.getElementById("mainNavbar");
        const announcementBar = document.getElementById("announcementBar");
        
        // Prüfe ob Announcement Bar sichtbar ist
        const isAnnouncementVisible = announcementBar && 
            announcementBar.classList.contains('announcement-bar--show');
            
        const announcementHeight = isAnnouncementVisible ? announcementBar.offsetHeight : 0;
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (mainNavbar) {
            if (currentScroll < lastScrollTop && currentScroll > 0) {
                // Wenn nach oben scrollt und nicht ganz oben
                mainNavbar.style.top = "0px";
                mainNavbar.classList.add("scrolled");
            } else if (currentScroll <= announcementHeight) {
                // Wenn im Bereich des Störers (nur wenn dieser sichtbar ist)
                mainNavbar.style.top = (announcementHeight - currentScroll) + "px";
                mainNavbar.classList.remove("scrolled");
            } else {
                // Nach unten scrollen
                mainNavbar.style.top = "-152px"; // Menü ausblenden
            }
        }
    }

    // Initial position setzen
    setMenuPosition();

    // Event Listener für Scroll
    window.addEventListener("scroll", function () {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        setMenuPosition();
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }, false);

    // Event Listener für Resize
    window.addEventListener("resize", setMenuPosition, false);

    // Event Listener für Announcement Bar Close Button
    const closeButton = document.querySelector('.announcement-close');
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            setTimeout(setMenuPosition, 0); // Neuberechnung nach dem Schließen des Störers
        });
    }
}

export default initFixedMenu;